import { httpInstance } from '@/services/httpInstance';

const getCurrentVersionsService = async () => {
  const endpoint = '/back-office/v1/device-version/last';
  const res = await httpInstance.get(endpoint);
  return res;
};

export default getCurrentVersionsService;
